module.exports = __webpack_public_path__ + "static/media/nft-fashion-icon1.ba3a74d3.svg";